import { useFormikContext } from 'formik';

import useNavigateBack from 'hooks/useNavigateBack';
import { useFormMutation } from 'mutations/useFormMutation';
import { useDreFormContext } from 'pages/financeiro/dre/contexts';
import { DreForm, RequestDreForm } from 'pages/financeiro/dre/types';

export function useMutateDre() {
    const { mutate, isLoading } = useFormMutation<RequestDreForm>();
    const { setDre, setStatus } = useDreFormContext();
    const formik = useFormikContext<DreForm>();
    const navigateBack = useNavigateBack();

    /**
     * Salva ou finaliza a DRE.
     */
    const submitDre = (finalizar: boolean) => {
        const url = '/dre/dremercadologicawrapper';
        const submitUrl = finalizar ? `${url}/finaliza` : url; // se estiver finalizando o sufixo da url é finaliza
        const method = finalizar ? 'POST' : 'PUT'; // se estiver finalizando o verbo é POST

        setStatus('SAVING');

        mutate(
            {
                method,
                formik,
                formData: formik.values,
                preventRedirect: true,
                url: `${submitUrl}/${formik.values.idDreMercadologica}`,
            },
            {
                onSuccess: (response) => {
                    const { data } = response.data;

                    if (finalizar) {
                        navigateBack();
                    } else if (data) {
                        setDre(data);
                    }
                },
                onSettled: () => setStatus(null),
            },
        );
    };

    return { submitDre, isLoading };
}
